var _rect, _rect2, _g, _circle, _circle2, _g2, _rect3, _rect4, _g3, _circle3, _path, _path2, _path3, _circle4, _circle5, _circle6, _circle7, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHow3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 358,
    viewBox: "0 0 510 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 58,
    width: 400,
    height: 300,
    rx: 24,
    fill: "#081131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 222,
    width: 462,
    height: 96,
    rx: 12,
    fill: "#162044"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 246,
    width: 100,
    height: 48,
    rx: 8,
    fill: "#4E5A85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 264,
    width: 48,
    height: 12,
    rx: 6,
    fill: "#7E8BB6"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 270,
    r: 32,
    fill: "#2DB27C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_833_10289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 238,
    width: 64,
    height: 64
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 270,
    r: 32,
    fill: "#FEECD0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_833_10289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 238,
    width: 64,
    height: 62,
    fill: "url(#pattern0)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 96,
    y: 254,
    width: 204,
    height: 12,
    rx: 6,
    fill: "#4E5A85"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 96,
    y: 274,
    width: 152,
    height: 12,
    rx: 6,
    fill: "#4E5A85"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_833_10289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 10,
    width: 182,
    height: 180,
    rx: 24,
    fill: "#5454D4"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 310,
    cy: 100,
    r: 56,
    stroke: "white",
    strokeWidth: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M253.961 99.9998C253.961 130.95 279.051 156.04 310.001 156.04C340.951 156.04 366.041 130.95 366.041 99.9998C366.041 69.0498 340.951 43.96 310.001 43.96",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M309.999 43.96C340.949 43.96 366.039 69.0498 366.039 99.9998C366.039 130.95 340.949 156.04 309.999 156.04C295.249 156.04 281.829 150.34 271.822 141.024",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M310 43.9602C340.95 43.9602 366.04 69.0501 366.04 100C366.04 122.296 353.019 141.551 334.167 150.575",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.96,
    cy: 100.7,
    r: 1.401,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.473,
    cy: 140.629,
    r: 1.401,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.817,
    cy: 150.436,
    r: 1.401,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.001,
    cy: 43.9601,
    r: 1.401,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M290.167 108L296.623 90.48H299.383L292.927 108H290.167ZM288.919 100.032C287.991 100.032 287.223 99.824 286.615 99.408C286.007 98.976 285.551 98.408 285.247 97.704C284.959 97 284.815 96.232 284.815 95.4V94.776C284.815 93.864 284.967 93.064 285.271 92.376C285.575 91.672 286.031 91.128 286.639 90.744C287.263 90.344 288.023 90.144 288.919 90.144C289.847 90.144 290.615 90.344 291.223 90.744C291.831 91.128 292.287 91.672 292.591 92.376C292.895 93.064 293.047 93.864 293.047 94.776V95.4C293.047 96.232 292.895 97 292.591 97.704C292.303 98.408 291.855 98.976 291.247 99.408C290.655 99.824 289.879 100.032 288.919 100.032ZM288.919 97.8C289.495 97.8 289.919 97.592 290.191 97.176C290.479 96.744 290.623 96.056 290.623 95.112C290.623 94.088 290.479 93.376 290.191 92.976C289.903 92.576 289.479 92.376 288.919 92.376C288.359 92.376 287.935 92.576 287.647 92.976C287.375 93.376 287.239 94.08 287.239 95.088C287.239 96.032 287.375 96.72 287.647 97.152C287.935 97.584 288.359 97.8 288.919 97.8ZM300.511 108.36C299.583 108.36 298.815 108.152 298.207 107.736C297.599 107.304 297.143 106.736 296.839 106.032C296.551 105.328 296.407 104.56 296.407 103.728V103.104C296.407 102.192 296.559 101.392 296.863 100.704C297.167 100 297.623 99.456 298.231 99.072C298.855 98.672 299.615 98.472 300.511 98.472C301.439 98.472 302.207 98.672 302.815 99.072C303.423 99.456 303.879 100 304.183 100.704C304.487 101.392 304.639 102.192 304.639 103.104V103.728C304.639 104.56 304.487 105.328 304.183 106.032C303.895 106.736 303.447 107.304 302.839 107.736C302.247 108.152 301.471 108.36 300.511 108.36ZM300.511 106.128C301.087 106.128 301.511 105.92 301.783 105.504C302.071 105.072 302.215 104.384 302.215 103.44C302.215 102.416 302.071 101.704 301.783 101.304C301.495 100.904 301.071 100.704 300.511 100.704C299.951 100.704 299.527 100.904 299.239 101.304C298.967 101.704 298.831 102.408 298.831 103.416C298.831 104.36 298.967 105.048 299.239 105.48C299.527 105.912 299.951 106.128 300.511 106.128ZM312.486 89.976C313.782 89.976 314.878 90.2 315.774 90.648C316.686 91.08 317.422 91.68 317.982 92.448C318.542 93.216 318.95 94.112 319.206 95.136C319.462 96.144 319.59 97.216 319.59 98.352V99.408C319.59 102.272 318.862 104.448 317.406 105.936C315.966 107.408 313.846 108.144 311.046 108.144C310.438 108.144 309.87 108.128 309.342 108.096C308.814 108.064 308.286 108.016 307.758 107.952V105.096C308.286 105.16 308.822 105.208 309.366 105.24C309.926 105.272 310.526 105.288 311.166 105.288C312.51 105.288 313.566 105.056 314.334 104.592C315.102 104.128 315.646 103.448 315.966 102.552C316.302 101.656 316.47 100.544 316.47 99.216V97.656L317.238 96.552C317.222 97.784 316.974 98.808 316.494 99.624C316.03 100.424 315.382 101.032 314.55 101.448C313.718 101.848 312.766 102.048 311.694 102.048C310.446 102.048 309.382 101.8 308.502 101.304C307.622 100.808 306.942 100.12 306.462 99.24C305.998 98.36 305.766 97.336 305.766 96.168C305.766 94.952 306.038 93.88 306.582 92.952C307.126 92.008 307.894 91.28 308.886 90.768C309.894 90.24 311.094 89.976 312.486 89.976ZM312.558 92.832C311.806 92.832 311.166 92.976 310.638 93.264C310.11 93.536 309.71 93.92 309.438 94.416C309.166 94.912 309.03 95.48 309.03 96.12C309.03 96.776 309.158 97.352 309.414 97.848C309.686 98.344 310.078 98.728 310.59 99C311.102 99.272 311.718 99.408 312.438 99.408C313.126 99.408 313.75 99.288 314.31 99.048C314.886 98.792 315.334 98.424 315.654 97.944C315.99 97.448 316.158 96.84 316.158 96.12C316.158 95.496 316.022 94.936 315.75 94.44C315.494 93.944 315.094 93.552 314.55 93.264C314.022 92.976 313.358 92.832 312.558 92.832ZM329.087 108.504C327.791 108.504 326.687 108.288 325.775 107.856C324.879 107.408 324.151 106.8 323.591 106.032C323.031 105.264 322.623 104.376 322.367 103.368C322.111 102.344 321.983 101.264 321.983 100.128V99.072C321.983 96.208 322.703 94.04 324.143 92.568C325.599 91.08 327.727 90.336 330.527 90.336C331.135 90.336 331.703 90.352 332.231 90.384C332.759 90.416 333.287 90.464 333.815 90.528V93.384C333.287 93.32 332.743 93.272 332.183 93.24C331.639 93.208 331.047 93.192 330.407 93.192C329.063 93.192 328.007 93.424 327.239 93.888C326.471 94.352 325.919 95.032 325.583 95.928C325.263 96.824 325.103 97.936 325.103 99.264V100.824L324.335 101.928C324.351 100.696 324.591 99.68 325.055 98.88C325.535 98.064 326.191 97.456 327.023 97.056C327.855 96.64 328.807 96.432 329.879 96.432C331.127 96.432 332.191 96.68 333.071 97.176C333.951 97.672 334.623 98.36 335.087 99.24C335.567 100.12 335.807 101.144 335.807 102.312C335.807 103.528 335.535 104.608 334.991 105.552C334.447 106.48 333.671 107.208 332.663 107.736C331.671 108.248 330.479 108.504 329.087 108.504ZM329.015 105.648C329.767 105.648 330.407 105.512 330.935 105.24C331.463 104.952 331.863 104.56 332.135 104.064C332.407 103.568 332.543 103 332.543 102.36C332.543 101.704 332.407 101.128 332.135 100.632C331.879 100.136 331.495 99.752 330.983 99.48C330.471 99.208 329.855 99.072 329.135 99.072C328.447 99.072 327.815 99.2 327.239 99.456C326.679 99.696 326.231 100.064 325.895 100.56C325.575 101.04 325.415 101.64 325.415 102.36C325.415 102.984 325.543 103.544 325.799 104.04C326.071 104.536 326.471 104.928 326.999 105.216C327.543 105.504 328.215 105.648 329.015 105.648Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M415.125 299.5C414.75 299 414.375 298.125 413.625 297C413.25 296.375 412.125 295.125 411.75 294.625C411.5 294.125 411.5 293.875 411.625 293.375C411.75 292.625 412.5 292 413.375 292C414 292 414.625 292.5 415.125 292.875C415.375 293.125 415.75 293.625 416 293.875C416.25 294.125 416.25 294.25 416.5 294.5C416.75 294.875 416.875 295.125 416.75 294.625C416.625 294 416.5 293 416.25 292C416.125 291.25 416 291.125 415.875 290.625C415.75 290 415.625 289.625 415.5 289C415.375 288.625 415.25 287.625 415.125 287.125C415 286.5 415 285.375 415.5 284.875C415.875 284.5 416.625 284.375 417.125 284.625C417.75 285 418.125 285.875 418.25 286.25C418.5 286.875 418.75 287.75 418.875 288.75C419.125 290 419.5 291.875 419.5 292.25C419.5 291.75 419.375 290.875 419.5 290.375C419.625 290 419.875 289.5 420.375 289.375C420.75 289.25 421.125 289.25 421.5 289.25C421.875 289.375 422.25 289.625 422.5 289.875C423 290.625 423 292.25 423 292.125C423.125 291.625 423.125 290.625 423.375 290.125C423.5 289.875 424 289.625 424.25 289.5C424.625 289.375 425.125 289.375 425.5 289.5C425.75 289.5 426.25 289.875 426.375 290.125C426.625 290.5 426.75 291.75 426.875 292.25C426.875 292.375 427 291.75 427.25 291.375C427.75 290.625 429.5 290.375 429.625 292.125C429.625 293 429.625 292.875 429.625 293.5C429.625 294.125 429.625 294.5 429.625 295C429.625 295.5 429.5 296.625 429.375 297.125C429.25 297.5 428.875 298.375 428.5 298.875C428.5 298.875 427.125 300.375 427 301.125C426.875 301.875 426.875 301.875 426.875 302.375C426.875 302.875 427 303.5 427 303.5C427 303.5 426 303.625 425.5 303.5C425 303.375 424.375 302.5 424.25 302.125C424 301.75 423.625 301.75 423.375 302.125C423.125 302.625 422.5 303.5 422 303.5C421.125 303.625 419.375 303.5 418.125 303.5C418.125 303.5 418.375 302.25 417.875 301.75C417.5 301.375 416.875 300.75 416.5 300.375L415.125 299.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M415.125 299.5C414.75 299 414.375 298.125 413.625 297C413.25 296.375 412.125 295.125 411.75 294.625C411.5 294.125 411.5 293.875 411.625 293.375C411.75 292.625 412.5 292 413.375 292C414 292 414.625 292.5 415.125 292.875C415.375 293.125 415.75 293.625 416 293.875C416.25 294.125 416.25 294.25 416.5 294.5C416.75 294.875 416.875 295.125 416.75 294.625C416.625 294 416.5 293 416.25 292C416.125 291.25 416 291.125 415.875 290.625C415.75 290 415.625 289.625 415.5 289C415.375 288.625 415.25 287.625 415.125 287.125C415 286.5 415 285.375 415.5 284.875C415.875 284.5 416.625 284.375 417.125 284.625C417.75 285 418.125 285.875 418.25 286.25C418.5 286.875 418.75 287.75 418.875 288.75C419.125 290 419.5 291.875 419.5 292.25C419.5 291.75 419.375 290.875 419.5 290.375C419.625 290 419.875 289.5 420.375 289.375C420.75 289.25 421.125 289.25 421.5 289.25C421.875 289.375 422.25 289.625 422.5 289.875C423 290.625 423 292.25 423 292.125C423.125 291.625 423.125 290.625 423.375 290.125C423.5 289.875 424 289.625 424.25 289.5C424.625 289.375 425.125 289.375 425.5 289.5C425.75 289.5 426.25 289.875 426.375 290.125C426.625 290.5 426.75 291.75 426.875 292.25C426.875 292.375 427 291.75 427.25 291.375C427.75 290.625 429.5 290.375 429.625 292.125C429.625 293 429.625 292.875 429.625 293.5C429.625 294.125 429.625 294.5 429.625 295C429.625 295.5 429.5 296.625 429.375 297.125C429.25 297.5 428.875 298.375 428.5 298.875C428.5 298.875 427.125 300.375 427 301.125C426.875 301.875 426.875 301.875 426.875 302.375C426.875 302.875 427 303.5 427 303.5C427 303.5 426 303.625 425.5 303.5C425 303.375 424.375 302.5 424.25 302.125C424 301.75 423.625 301.75 423.375 302.125C423.125 302.625 422.5 303.5 422 303.5C421.125 303.625 419.375 303.5 418.125 303.5C418.125 303.5 418.375 302.25 417.875 301.75C417.5 301.375 416.875 300.75 416.5 300.375L415.125 299.5Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M425.5 299.875V295.625",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M423 299.875L422.875 295.625",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M420.5 295.625V299.875",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_833_10289",
    transform: "translate(0 -0.016129) scale(0.0625 0.0645161)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_833_10289",
    x: 174,
    y: 0,
    width: 272,
    height: 270,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.054902 0 0 0 0 0.152941 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_833_10289"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_833_10289",
    result: "shape"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_833_10289",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADtSURBVHgBrZMvC8JAGMbfiTCLBrUORESU4QcwahQNljXFbBKWbMPsRBAEs82ioK6p1W5QwTZsY0EQLDK5Bbf74wnOH4y75/Y+z97dccL6bjkQgBAE5P8B20vdfXhzP4J/D1gFJOXMHNNhsqAv9oCHQejQJ7OQK2GFpGYG/AIWYEiF99w57bBCUjMDEAm5C6oS9xbMI/MDzIBGrAoteQKLs+6FSHl3QHpTvFIB1Ckgc6emwXCpASgq9i6VjfI78INC9JlNrVfMA6YF8jKh37Cfe0iLTco8sgffO5jeVpiBZeJ2gHiMk+4YaVtM7ecFJOZQ5lr+CWAAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow3);
export default __webpack_public_path__ + "static/media/how3.e3f176f90612622bce0730a6714c31a6.svg";
export { ForwardRef as ReactComponent };